/**
 * @generated SignedSource<<da4782b75e26365b02ebb920f0c17f54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespHolidayGiftCollection_itemSearch$data = {
  readonly browseContentModule: {
    readonly " $fragmentSpreads": FragmentRefs<"SbRespHolidayGiftCollectionLinks_browseContentModule">;
  } | null;
  readonly " $fragmentType": "SbRespHolidayGiftCollection_itemSearch";
};
export type SbRespHolidayGiftCollection_itemSearch$key = {
  readonly " $data"?: SbRespHolidayGiftCollection_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespHolidayGiftCollection_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespHolidayGiftCollection_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "browseContentModule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespHolidayGiftCollectionLinks_browseContentModule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "4a0caa0fa557b2da53e9d35debe98d5d";

export default node;
